// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"916":"58b3fa76","970":"603c1ae5"}[chunkId] + ".chunk.js";
};